import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { GameTicketState, GameTicketStore } from './game-ticket.store';
import { combineLatest, map } from "rxjs";
import { TicketQuery } from "../tickets/state/ticket.query";
import { TICKET_TRANSFER_STATUS } from '../tickets/models/ticket-status.enum';
import { DateTime } from "luxon";

@Injectable({ providedIn: 'root' })
export class GameTicketQuery extends QueryEntity<GameTicketState> {
  
  constructor(protected store: GameTicketStore, private ticketQuery: TicketQuery) {
    super(store);
  }

  getGameWithTicketByGameNumber(gameNumber: number) {
    return this.selectAll({
        filterBy: (game) => game.GameNumber === gameNumber
    }).pipe(map((game) => game[0]));
  }

  selectGamesWithTickets() {
    return this.selectAll();
  }

  selectGameDetailsByGameNumber(gameNumber: number) {
    return combineLatest([
              this.getGameWithTicketByGameNumber(gameNumber),
              this.ticketQuery.selectDefaultTicket(gameNumber)
            ]).pipe(
              map(([game, ticket]) => {
                let isPastGame = false;
                
                const pastGame = DateTime.fromISO(game?.Date as string, { zone: 'utc' }).endOf('day') < DateTime.utc();
                if(!pastGame && game?.TicketsAvailableToTransfer === 0 && game?.TicketsTransferred === 0 && game?.TotalAmountOfTickets === 0 ){
                    return { game, ticket, status: TICKET_TRANSFER_STATUS.NO_AVAILABLE_TRANSFERS, isPastGame };
                }
                
                const dateNow = DateTime.utc();
                const startDate = DateTime.fromISO(ticket?.StartTime as string, { zone: 'utc' });
                const endDate = DateTime.fromISO(ticket?.EndTime as string, { zone: 'utc' });
                const minDateString = DateTime.fromISO('0001-01-01T00:00:00', { zone: 'utc' }) ;

                // Check if request time is equal to the min date string, if it is then the transfer window is closed.
                if( !ticket || (pastGame && DateTime.fromISO(ticket?.RequestTime as string, { zone: 'utc' }).toISODate() === minDateString.toISODate()) ){
                    isPastGame = true;
                }
            
                if( endDate < dateNow){
                    return { game, ticket, status:  TICKET_TRANSFER_STATUS.CLOSED, isPastGame };
                }else if (startDate > dateNow){
                    return { game, ticket, status:  TICKET_TRANSFER_STATUS.NOT_OPEN, isPastGame };
                }else{
                    return { game, ticket, status:  TICKET_TRANSFER_STATUS.OPEN, isPastGame };
                }
              })
            );
    }
}